import ReactDOM from 'react-dom/client'
import { App } from './App.tsx'
import { ThemeProvider, RegistryProvider } from '@/contexts'
import { SessionProvider } from './contexts/SessionProvider'
import { banner } from './lib/banner.ts'
import { IndexedDBProvider } from './datastore/contexts/IndexedDBProvider.tsx'
import { SupportedLanguagesProvider } from './datastore/contexts/SupportedLanguagesProvider.tsx'
import { RepositoryEventsProvider } from './contexts/RepositoryEventsProvider.tsx'
import { Init } from './components/Init/index.tsx'
import { UserMessagesReceiver } from './components/UserMessagesReceiver.tsx'
import { ThemedToaster } from './components/ThemedToaster.tsx'
import './index.css'
import './print.css'
import { SettingsProvider } from './modules/userSettings/SettingsProvider.tsx'

banner()

const root = document.getElementById('root')

if (!root) {
  throw new Error('Can not getElementById("root")')
}

ReactDOM.createRoot(root).render(
  <>
    <IndexedDBProvider>
      <RegistryProvider>
        <SessionProvider>
          <RepositoryEventsProvider>
            <SupportedLanguagesProvider>
              <ThemeProvider defaultTheme='light' storageKey='ele-ui-theme'>
                <Init>
                  <SettingsProvider application='se.ecms.elephant-chrome'>
                    <UserMessagesReceiver>
                      <App />
                    </UserMessagesReceiver>
                  </SettingsProvider>
                </Init>
                <ThemedToaster />
              </ThemeProvider>
            </SupportedLanguagesProvider>
          </RepositoryEventsProvider>
        </SessionProvider>
      </RegistryProvider>
    </IndexedDBProvider>
  </>
)
